import * as Yup from "yup";
import { ExtendedFieldsSourceType } from "us.collection.admin/constants";
import { ExtendedFieldDataTypes } from "us.common/constants";
import { ExtendedField } from "us.collection.admin/interfaces";

const isDuplicateFieldName = (
  existingValues: ExtendedField[],
  fieldName: string,
  isEdit: boolean
) => {
  if(isEdit == false){
     return existingValues
    ?.some(
      (item: any) =>
        item.fieldName?.trim()?.toLowerCase() ===
        fieldName?.trim()?.toLowerCase()
    );
  } else {
    return false;
  } 
};

export const extendedFieldValidationSchema = (existingValues: any) =>
  Yup.object({
    fieldCategory: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.CATEGORY_IS_REQUIRED"
    ),
    fieldName: Yup.string()
      .required("US.COLLECTION.VALIDATIONS:INVALID.PLEASE_ADD_A_VALUE_INTO_THE_FIELD")
      .test(
        "is-duplicate",
        "US.COLLECTION.VALIDATIONS:INVALID.THIS_NAME_IS_ALREADY_TAKEN",
        function (value) {
          const isEdit = this.parent?.id == -1 ? false : true;
          return !isDuplicateFieldName(
            existingValues,
            value || "",
            isEdit
          );
        }
      ),
    description: Yup.string()
      .trim()
      .max(
        500,
        "US.COLLECTION.VALIDATIONS:REQUIRED.DESCRIPTION_CANNOT_EXCEED_500_CHARACTERS"
      ),
    dataTypeId: Yup.string().required(
      "US.COLLECTION.VALIDATIONS:REQUIRED.VALUE_TYPE_IS_REQUIRED"
    ),
    valueType: Yup.string().when("dataType", {
      is: (dataType) =>
        dataType?.trim()?.toLowerCase() === ExtendedFieldDataTypes.CUSTOM,
      then: Yup.string().required(
        "US.COLLECTION.VALIDATIONS:REQUIRED.STORED_PROCEDURE_IS_REQUIRED"
      ),
      otherwise: Yup.string().nullable().notRequired(),
    }),
    storedProcedure: Yup.string().when(["valueType", "dataType"], {
      is: (valueType, dataType) =>
        valueType === ExtendedFieldsSourceType.SP &&
        dataType?.trim()?.toLowerCase() === ExtendedFieldDataTypes.CUSTOM,
      then: Yup.string().required(
        "US.COLLECTION.VALIDATIONS:REQUIRED.STORED_PROCEDURE_IS_REQUIRED"
      ),
      otherwise: Yup.string().nullable(),
    }),
    valueList: Yup.array().when(["valueType", "dataType"], {
      is: (valueType, dataType) =>
        valueType === ExtendedFieldsSourceType.VALUE &&
        dataType?.trim()?.toLowerCase() === ExtendedFieldDataTypes.CUSTOM,
      then: Yup.array()
        .of(
          Yup.string()
            .trim()
            .required("US.COLLECTION.VALIDATIONS:REQUIRED.VALUE_IS_REQUIRED")
        )
        .min(1, "US.COLLECTION.VALIDATIONS:REQUIRED.VALUE_CANNOT_BE_EMPTY"),
      otherwise: Yup.array().nullable(),
    }),
  });
